import { Common } from '@factorin/domain';
import { put } from 'redux-saga/effects';

import { useAction, useSelector } from 'Modules/core/redux';

import { environmentActions } from './actions';


const ENVIRONMENT_KEY = 'environment';

export const PARAMETERS_KEY = 'parameters';

export const useEnvironment = <TType = any, TReturn = Common.Catalog<TType>>(
    path: string,
): TReturn => {
    const result = useSelector<TReturn>(`${ENVIRONMENT_KEY}.${path}`, [path]);
    return result;
};

export const useBusy = (path: string): boolean =>
    useSelector(`${ENVIRONMENT_KEY}.${path}.busy`, [path]);

export const withBusyWrapper = path => next =>
    function* busyWrapper() {
        yield put(environmentActions.setBusy(path)(true));
        yield next();
        yield put(environmentActions.setBusy(path)(false));
    };

interface UpdateParameters {
    sorting?: string | null;
    filters?: {
        [x: string]: any;
    };
}

export const useEnvParameters = (key: string) => {
    const parameters = useSelector(
        `${ENVIRONMENT_KEY}.${PARAMETERS_KEY}.${key}`,
        [key],
    );
    const updateParameters = useAction(({ filters, sorting }: UpdateParameters) =>
        environmentActions.setParameters({
            key,
            params: {
                ...parameters,
                filters: filters || parameters?.filters,
                ...parameters?.descending && sorting === parameters.sorting ? {
                    sorting: null,
                    descending: null,
                } : {
                    sorting: sorting || parameters?.sorting,
                    descending: typeof parameters?.descending === 'boolean' &&
                        sorting === parameters.sorting ? !parameters?.descending : false,
                },
            },
        }), [key, parameters]);
    return {
        parameters,
        updateParameters,
    };
};
